module.exports = __webpack_public_path__ + "app/docrepo-invoice/grid-2SXjgnDf.html";